import QAServiceDetail from "./QAServiceDetail";

export default QAServiceDetail;
